import DOMPurify from 'dompurify';

/**
 * Sanitize HTML to prevent XSS attacks.
 * Use this instead of raw dangerouslySetInnerHTML.
 */
export const sanitizeHtml = (dirty) => {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: [
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'br', 'hr',
      'ul', 'ol', 'li', 'strong', 'em', 'b', 'i', 'u', 's',
      'a', 'img', 'blockquote', 'pre', 'code',
      'table', 'thead', 'tbody', 'tr', 'th', 'td',
      'div', 'span', 'figure', 'figcaption', 'video', 'source',
      'iframe',
    ],
    ALLOWED_ATTR: [
      'href', 'src', 'alt', 'title', 'class', 'id', 'target',
      'rel', 'width', 'height', 'style', 'controls', 'allowfullscreen',
      'frameborder', 'allow',
    ],
    ALLOW_DATA_ATTR: false,
  });
};

/**
 * Returns a safe props object for dangerouslySetInnerHTML.
 * Usage: <div {...safeHtml(content)} />
 */
export const safeHtml = (content) => ({
  dangerouslySetInnerHTML: { __html: sanitizeHtml(content) },
});
